import SiteLayout from "@/components/feature/SiteLayout";
import HeroSection from "@/pages/home/components/HeroSection";
import CompanySection from "@/pages/home/components/CompanySection";
import CtaSection from "@/pages/home/components/CtaSection";

export default function Home() {
  return (
    <SiteLayout>
      <HeroSection />
      <CompanySection />
      <CtaSection />
    </SiteLayout>
  );
}